<template>
  <el-drawer :visible="visible" :modal="false" direction="btt" :withHeader="false" size="100%"
    custom-class="no-animation">
    <rhcn-drawer title="message.permission.addOperator" :description="$t('message.permission.addOperatorDesc')"
      @on-close="onClose">
      <div class="operator-modal-wrapper">
        <div class="form-wrapper">
          <validation-component ref="appForm" :validation-condition="operatorCondition">
            <template #phone>
              <el-input v-model="form.phone" maxlength="15"
                :placeholder="$t('message.validator.input', { input: $t('message.user.phone') })" @input="onPhoneInput">
                <el-select v-model="form.areaCode" slot="prepend" filterable>
                  <el-option v-for="(item, index) in PHONE_AREAS" :key="index" :label="item.label"
                    :value="item.value">{{ item.description }}</el-option>
                </el-select>
              </el-input>
            </template>
            <template #code>
              <div class="captcha-box">
                <el-input class="captcha-input" v-model="form.captcha"
                  :placeholder="$t('message.validator.input', { input: $t('message.user.captcha') })"></el-input>
                <div>
                  <el-button v-loading="requestingCode" class="btn-captcha" @click="sendCaptcha">{{ captchaLeftTime > 0 ?
                    `${captchaLeftTime}s` : $t('message.user.sendCaptcha')}}</el-button>
                </div>
              </div>
            </template>
          </validation-component>
          <div class="margin-top-25 margin-bottom-25">
            <el-button style="width: 100%" type="primary" :loading="requesting" @click="submitCreateOperator">{{
              $t("message.common.submit") }}</el-button>
          </div>
        </div>
      </div>
    </rhcn-drawer>
  </el-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

import { getDictionary } from '@/api/common/index';
import { PHONE_AREAS } from '@/api/common/phone-area.js';
import RhcnDrawer from '@/components/drawer/index.vue';
import { ShowSuccessMessage, ShowWarningMessage } from '@/components/modal/tips/message-tips.js';
import { REQUIRED, EMAIL, VALIDATE_PASSWORD, PASSWORD_LENGTH, PASSWORD_STRENGTH } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { addOperator, getPhoneCaptcha } from '@/views/account/permission/api/operator';
import { getRoleNames } from '@/views/account/permission/api/role';

export default {
  components: {
    RhcnDrawer,
    ValidationComponent,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requesting: false,
      roleList: [],
      statusList: [],
      operatorCondition: [{
        key: 'operatorName',
        name: 'message.permission.name',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.permission.name',
        rule: [REQUIRED],
      }, {
        key: 'operatorEmail',
        name: 'message.user.loginEmail',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.user.loginEmail',
        rule: [REQUIRED, EMAIL],
      }, {
        key: 'contactEmail',
        name: 'message.user.contactEmail',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.user.contactEmail',
        rule: [REQUIRED, EMAIL],
      }, {
        key: 'password',
        name: 'message.permission.password',
        type: 'password',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.permission.password',
        rule: [REQUIRED, VALIDATE_PASSWORD, PASSWORD_LENGTH, PASSWORD_STRENGTH],
      }, {
        key: 'passwordRepeat',
        name: 'message.permission.passwordRepeat',
        type: 'password',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.permission.passwordRepeat',
        rule: [REQUIRED],
        validator: (rule, value, callback) => {
          if (value !== this.$refs.appForm.getItemValue('password')) {
            callback(new Error(this.$t('message.validator.passwordConfirm')));
          }
          callback();
        },
      }, {
        key: 'roleId',
        name: 'message.permission.role',
        type: 'select',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.permission.role',
        rule: [REQUIRED],
        option: {
          label: 'roleName',
          value: 'id',
        },
      }, {
        key: 'chargebackNotify',
        name: 'message.permission.receiveEmail',
        type: 'checkbox',
        placeholder: 'message.status.refuse',
        defValue: false,
      }, {
        key: 'status',
        name: 'message.permission.status',
        type: 'select',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.permission.status',
        rule: [REQUIRED],
        option: {
          label: 'description',
          value: 'value',
        },
      }],
      form: {
        phone: '',
        areaCode: '+44',
      },
      captchaLeftTime: 0,
      requestingCode: false,
      showPhoneNumber: false,
      PHONE_AREAS,
    };
  },
  watch: {
    visible(value) {
      if (value) {
        this.initData();
      } else {
        this.timer && clearTimeout(this.timer);
        this.captchaLeftTime = 0;
      }
    },
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  created() {
    console.log('this.app.userLogin', this.app.userLogin);
    if (this.app.userLogin.businessType === '0' || this.app.userLogin.isAggregateMerchant) {
      this.operatorCondition.push({
        key: 'phone',
        name: 'message.user.phone',
        type: 'slot',
        isShowStar: true,
        // rule: [REQUIRED],
      });
      this.operatorCondition.push({
        key: 'code',
        name: 'message.user.captcha',
        type: 'slot',
        isShowStar: true,
        // rule: [REQUIRED],
      });

      this.showPhoneNumber = true;
    }
  },
  mounted() {
    this.initData();
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer);
    this.captchaLeftTime = 0;
  },
  methods: {
    addOperator,
    async initData() {
      this.form = {
        phone: '',
        areaCode: '+44',
      };

      const roles = await getRoleNames();
      this.roleList = [
        ...roles,
      ];
      if (this.statusList.length === 0) {
        const dict = await getDictionary(['COMMON_STATUS']);
        this.statusList = dict.COMMON_STATUS;
      }

      // this.operatorCondition[5].options = this.roleList;
      // this.operatorCondition[6].options = this.statusList;
      if (this.$refs.appForm) {
        this.$refs.appForm.setValidationSelectOptions('roleId', this.roleList);
        this.$refs.appForm.setValidationSelectOptions('status', this.statusList);
      }
    },
    onClose() {
      this.$refs.appForm.formReset();
      this.$emit('close');
    },
    async onSubmit(params) {
      this.requesting = true;
      try {
        await addOperator(params);
        ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
        this.onClose();
        this.$emit('refresh');
      } catch (err) { }
      this.requesting = false;
    },
    submitCreateOperator() {
      this.$refs.appForm.toFormValid((params) => {
        const data = {
          ...params,
        };
        if (this.showPhoneNumber) {
          if (!this.form.phone) {
            ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.phone') }));
            return;
          }

          if (this.form.areaCode === '+86') { // 中国大陆
            if (!(/^1[3456789]\d{9}$/.test(this.form.phone))) {
              ShowWarningMessage(this.$t('message.validator.inputPhone'));
              return;
            }
          }
          if (this.form.areaCode === '+852') { // 中国香港
            if (!(/([6|9])\d{7}$/.test(this.form.phone))) {
              ShowWarningMessage(this.$t('message.validator.inputPhone'));
              return;
            }
          }

          if (!this.form.captcha) {
            ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.captcha') }));
            return;
          }
          data.operatorPhoneNumber = this.form.phone;
          data.areaCode = this.form.areaCode;
          data.captcha = this.form.captcha;
        }

        this.onSubmit(data);
      });
    },
    async sendCaptcha() {
      if (this.captchaLeftTime > 0 || this.requestingCode) {
        return;
      }
      if (!this.form.phone) {
        ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.phone') }));
        return;
      }

      if (this.form.areaCode === '+86') { // 中国大陆
        if (!(/^1[3456789]\d{9}$/.test(this.form.phone))) {
          ShowWarningMessage(this.$t('message.validator.inputPhone'));
          return;
        }
      }

      if (this.form.areaCode === '+852') { // 中国香港
        if (!(/([6|9])\d{7}$/.test(this.form.phone))) {
          ShowWarningMessage(this.$t('message.validator.inputPhone'));
          return;
        }
      }

      this.requestingCode = true;
      try {
        const lang = this.$store.getters.app.currentLan;
        const language = lang === 'zh-cn' ? 'zh' : lang;
        await getPhoneCaptcha({
          phone: this.form.phone.trim(),
          areaCode: this.form.areaCode,
          language,
        });
        if (this.timer) {
          clearInterval(this.timer);
        }

        this.captchaLeftTime = 59;
        this.timer = setInterval(() => {
          this.captchaLeftTime -= 1;
          if (this.captchaLeftTime <= 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      } catch (err) {

      }
      this.requestingCode = false;
    },
    onPhoneInput(value) {
      const v = value.match(/^\d*(\d{0,10})/g)[0];
      this.form.phone = v;
    },
  },
};
</script>

<style lang="scss" scoped>
.operator-modal-wrapper {
  .form-wrapper {
    width: 450px;
    margin: 23px auto 0;

    .captcha-box {
      width: 100%;
      display: flex;
      align-content: center;

      .captcha-input {
        flex: 1;
        margin-right: 12px;
      }

      .btn-captcha {
        min-width: 120px;
        height: 44px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
